module.exports = __webpack_public_path__ + "static/media/26UNRWA4.dd2be0eb.jpg";